import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { EscapedMessage } from '../../common/types';

export type RenderedEscapedMessageProps = {
  message: EscapedMessage;
};

export default function RenderedEscapedMessage(props: RenderedEscapedMessageProps) {
  const { message } = props;

  // TODO add escaped icon and outline
  const textContent = (
    <div className="space-y-2 bg-gray-800 rounded-lg shadow-md py-2 px-4 border border-yellow-500">
      <h3 className="text-base font-semibold">Escaped</h3>
      <ReactMarkdown
        // Note: We replace all newlines with two spaces and a newline to ensure that the markdown
        // renderer correctly renders line breaks.
        children={message.content.replaceAll('\n', '  \n')}
        className="prose prose-sm md:prose-lg lg:prose-xl"
        components={{
          ul: ({ node, ...props }) => <ul className="list-disc list-inside pl-2" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal list-inside pl-2" {...props} />,
          li: ({ node, ...props }) => <li className="mb-2 space-y-4" {...props} />,
          div: ({ node, ...props }) => <div {...props} className="space-y-4" />,
          code: ({ node, ...props }) => (
            <code
              {...props}
              className="bg-gray-800 text-gray-300 p-1 rounded-lg break-words whitespace-pre-wrap"
            />
          ),
        }}
        remarkPlugins={[remarkGfm]}
      />
    </div>
  );

  return textContent;
}
